import { gsap } from "gsap";

// ---------------- Появление модального окна (оверлей + диалог)
/*
	Опции:
	 - dialogDuration (число) — длительность появления диалога
	 - overlayDuration (число) — длительность появления оверлея
	 - ease (строка) — easing для диалога
	 - y (число) — начальное смещение по Y в px (transform)
	 - scale (число) — начальный масштаб диалога
*/
type ShowModalOptions = {
	dialogDuration?: number;
	overlayDuration?: number;
	ease?: string;
	y?: number;
	scale?: number;
};

export const showModal = (
	overlay: HTMLElement,
	dialog: HTMLElement,
	options: ShowModalOptions = {},
) => {
	const {
		dialogDuration = 0.22,
		overlayDuration = 0.18,
		ease = "power2.out",
		y = 12,
		scale = 0.96,
	} = options;

	gsap.set(overlay, { opacity: 0 });
	gsap.set(dialog, { opacity: 0, scale, y });

	const timeline = gsap.timeline();

	timeline.to(overlay, {
		opacity: 1,
		duration: overlayDuration,
		ease: "power1.out",
	});

	timeline.to(
		dialog,
		{
			opacity: 1,
			scale: 1,
			y: 0,
			duration: dialogDuration,
			ease,
		},
		Math.min(overlayDuration * 0.35, overlayDuration * 0.5),
	);

	return timeline;
};
